import { includes, every, some } from "lodash";

const filters = ({
  investments,
  page,
  sort,
  priceMin,
  priceMax,
  category,
  mainTitle,
  surfacemin,
  surfacemax,
  amenities,
  contactLength,
  vacationsDays,
  backPercentage,
}) => {
  let filterred_investments = investments;

  if (!!mainTitle) {
    const letters = [
      "ą",
      "ć",
      "ę",
      "ł",
      "ń",
      "ó",
      "ś",
      "ź",
      "ż",
      "ö",
      "ô",
      "é",
      "&",
      "/",
      "-",
    ];
    const replacement = [
      "a",
      "c",
      "e",
      "l",
      "n",
      "o",
      "s",
      "z",
      "z",
      "o",
      "o",
      "e",
      "",
      "",
      "",
    ];

    let title = mainTitle?.toLowerCase();

    for (let i = 0; i < letters.length; ++i) {
      title = mainTitle
        ?.toLowerCase()
        ?.replaceAll(letters[i], replacement[i])
        ?.replace(/\s/g, "");
    }

    const investments_without_special_letters = filterred_investments?.map(
      (item) => {
        let clean_title = item?.title?.toLowerCase();

        for (let i = 0; i < letters.length; ++i) {
          clean_title = clean_title
            ?.replaceAll(letters[i], replacement[i])
            .replace(/\s/g, "");
        }

        return {
          ...item,
          title: clean_title,
        };
      }
    );

    filterred_investments = investments_without_special_letters.filter((item) =>
      new RegExp(title, "i").test(item?.title)
    );
  }

  if (!!category) {
    filterred_investments = filterred_investments.filter((item) =>
      some(category, (_category) => {
        return includes(item?.investments?.category, _category);
      })
    );
  }

  if (!!priceMin) {
    filterred_investments = filterred_investments.filter(
      (item) => item?.investments?.priceMin >= priceMin
    );
  }

  if (!!priceMax) {
    filterred_investments = filterred_investments.filter(
      (item) => item?.investments?.priceMin <= priceMax
    );
  }

  if (!!surfacemin) {
    filterred_investments = filterred_investments.filter(
      (item) => item?.investments?.surfacemin >= surfacemin
    );
  }

  if (!!surfacemax) {
    filterred_investments = filterred_investments.filter(
      (item) => item?.investments?.surfacemin <= surfacemax
    );
  }

  if (!!backPercentage) {
    filterred_investments = filterred_investments.filter((item) =>
      some(backPercentage, (_backPercentage) => {
        return item?.investments?.backPercentage === _backPercentage;
      })
    );
  }

  if (!!contactLength) {
    filterred_investments = filterred_investments.filter((item) =>
      some(contactLength, (_contactLength) => {
        return item?.investments?.contactLength === _contactLength;
      })
    );
  }

  if (!!vacationsDays) {
    filterred_investments = filterred_investments.filter((item) =>
      some(vacationsDays, (_vacationsDays) => {
        return item?.investments?.vacationsDaysCustom === _vacationsDays;
      })
    );
  }

  if (!!amenities) {
    filterred_investments = filterred_investments.filter((item) =>
      every(amenities, (amenity) => {
        return item?.investments[amenity];
      })
    );
  }

  const active_investments = filterred_investments.filter(
    (item) => !item.investments.ready
  );

  const inactive_investments = filterred_investments.filter(
    (item) => item.investments.ready
  );

  if (sort === "price") {
    active_investments.sort((a, b) =>
      a.investments.priceMin > b.investments.priceMin ? 1 : -1
    );
    inactive_investments.sort((a, b) =>
      a.investments.priceMin > b.investments.priceMin ? 1 : -1
    );
  }
  if (sort === "-price") {
    active_investments.sort((a, b) =>
      a.investments.priceMin > b.investments.priceMin ? -1 : 1
    );
    inactive_investments.sort((a, b) =>
      a.investments.priceMin > b.investments.priceMin ? -1 : 1
    );
  }
  if (sort === "date") {
    active_investments.sort((a, b) => (a.date > b.date ? 1 : -1));
    inactive_investments.sort((a, b) => (a.date > b.date ? 1 : -1));
  }
  if (sort === "-date") {
    active_investments.sort((a, b) => (a.date > b.date ? -1 : 1));
    inactive_investments.sort((a, b) => (a.date > b.date ? -1 : 1));
  }

  // if (sort === "popularForSorting") {
  //   active_investments.sort((a, b) => (a.date < b.date ? 1 : -1));
  //   inactive_investments.sort((a, b) => (a.date < b.date ? 1 : -1));
  // }

  const combined_data = [...active_investments, ...inactive_investments];

  const skip = (page - 1) * 9;

  let data_for_page = combined_data.slice(skip, skip + 9);

  return {
    data: data_for_page,
    data_for_map: combined_data,
    meta: { count: filterred_investments?.length },
  };
};

export default filters;
